import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { useAuth } from "@/core/auth";
import { formatCountdown, useCountdown } from "@/core/hooks";

interface ResendCodeButtonProps {
  onResend: () => Promise<void>;
}

export const ResendCodeButton = ({ onResend }: ResendCodeButtonProps) => {
  const { forgotPasswordEmail, getResetCodeResendAvailableAt } = useAuth();
  const secondsLeft = useCountdown(
    getResetCodeResendAvailableAt(forgotPasswordEmail),
  );
  const [isResending, setIsResending] = useState(false);

  const handleClick = async () => {
    setIsResending(true);
    try {
      await onResend();
    } finally {
      setIsResending(false);
    }
  };

  return (
    <Stack
      direction="row"
      align="center"
      justify="center"
      gap={0}
      className="flex-wrap"
    >
      <Text tone="muted">Didn&apos;t get a code?</Text>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="px-2 tabular-nums"
        disabled={secondsLeft > 0 || isResending}
        onClick={handleClick}
        aria-busy={isResending}
      >
        {secondsLeft > 0
          ? `Resend code in ${formatCountdown(secondsLeft)}`
          : "Resend code"}
      </Button>
    </Stack>
  );
};
